// extracted by mini-css-extract-plugin
export var gif = "_lg-0";